var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "bannedWords" } },
    [
      _c("supsis-table", {
        attrs: {
          columns: _vm.cols,
          rows: _vm.getFilteredRows(),
          "bottom-pagination": true,
          "pagination-cursor": _vm.paginationCursor,
          options: _vm.tableOptions,
        },
        on: {
          "cursor-changed": function (cursor) {
            return (_vm.paginationCursor = cursor)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center",
                  },
                  [
                    _c("a-input-search", {
                      staticClass: "search-input",
                      attrs: { placeholder: _vm.$t("message.search") },
                      on: { search: _vm.onSearch },
                      model: {
                        value: _vm.query,
                        callback: function ($$v) {
                          _vm.query = $$v
                        },
                        expression: "query",
                      },
                    }),
                    _vm._v(" "),
                    _vm.checkPermission(
                      _vm.PERMISSION_TYPES["bannedWord.create"].tr.name
                    )
                      ? _c(
                          "supsis-button",
                          {
                            attrs: { primary: "" },
                            on: { click: _vm.showModalWithoutEdit },
                          },
                          [
                            _c("md-icon", { staticStyle: { color: "white" } }, [
                              _vm._v("add"),
                            ]),
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("message.newBannedWord")) +
                                "\n                "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "banned-word-form",
                title: _vm.editMode
                  ? _vm.$t("message.updateBannedWordForm")
                  : _vm.$t("message.newBannedWordForm"),
                "show-footer": false,
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _vm.$validator.errors.items.length
                ? _c(
                    "a-alert",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        message: _vm.$t("message.error"),
                        showIcon: "",
                        type: "error",
                      },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "description" }, slot: "description" },
                        _vm._l(_vm.$validator.errors.items, function (err) {
                          return _c("div", [
                            _c("span", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(err.msg) +
                                  "\n                    "
                              ),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a-form",
                {
                  staticClass: "d-flex flex-column justify-content-center",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.handleSave.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                id: "name-input-group",
                                label: _vm.$t("message.word"),
                                "label-for": "name-input",
                              },
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  id: "name-input",
                                  name: _vm.$t("message.word"),
                                  placeholder: _vm.$t(
                                    "message.bannedWordAndWordGroup"
                                  ),
                                  autocomplete: "off",
                                  trim: "",
                                  type: "text",
                                },
                                model: {
                                  value: _vm.bannedWord.content,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.bannedWord, "content", $$v)
                                  },
                                  expression: "bannedWord.content",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-col",
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: _vm.$t("message.status") } },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  attrs: { name: "status", required: "" },
                                  model: {
                                    value: _vm.bannedWord.isActive,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.bannedWord, "isActive", $$v)
                                    },
                                    expression: "bannedWord.isActive",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: true } }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("message.active")) +
                                        "\n                            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio",
                                    {
                                      attrs: {
                                        value: false,
                                        id: "pasv_button",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.$t("message.passive")) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { id: "buttons" } },
                    [
                      _c(
                        "a-button",
                        { on: { click: _vm.hideModal } },
                        [
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.cancel")) +
                                "\n                    "
                            ),
                          ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          staticClass: "btn-primary",
                          attrs: {
                            disabled: _vm.loading,
                            type: "submit",
                            variant: "primary",
                          },
                          on: { click: _vm.handleSave },
                        },
                        [
                          !_vm.loading
                            ? [
                                !_vm.editMode
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.$t("message.save"))),
                                    ])
                                  : _c("span", [
                                      _vm._v(_vm._s(_vm.$t("message.update"))),
                                    ]),
                              ]
                            : [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "spinner", spin: "" },
                                }),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }